export const LinkTabs = arrayOfTabs =>
  Array.isArray(arrayOfTabs) && arrayOfTabs.reduce((acc, x) => {
    return acc && !!x.to &&
      typeof x.to === 'string' &&
      !!x.title &&
      typeof x.title === 'string'
  }, true)



// WEBPACK FOOTER //
// ./src/validators.js